<template>
    <template v-if="mainLoading">
        <div class="mainloading" v-if="loadingUrl">
            <img :src="loadingUrl" :style="`width:${loadingSize}px`" />
        </div>
    </template>

    <template v-else>
        <div v-if="isTop && totalCount > 0 && tabList[currentTabIndex].id !== 'selected'"
            class="goTopButton album-gotop" @click="scrollToTop"
            :style="tabList[currentTabIndex].id == 'photo' && albumDetail.labelType !== 'NONE' && labelList.length > 0 ? 'top: 100px;' : 'top: 69px;'">
            {{ topIndex }}/{{ totalCount }}
        </div>
        <div v-if="updatePhotoListFlag" class="updateTip" @click="handleUpdatePhotoList">{{ isEnglish?'There are photo updates, click to view':'有照片更新，点击查看' }}</div>
        <div class="album app-background" id="context"
            :style="albumDetail.discount && multipleChoseModal ? 'padding-bottom:100px' : ''">
            <div class="header" id="header">
                <Banner v-if="albumDetail.banner" :banner="albumDetail.banner" />
                <div class="album-info-container" :style="`padding: 12px 15px;min-height:20px`">
                    <img :src="computedResources('album-info.png')" class="album-info-bg" />
                    <template v-for="(item, index) in albumDetail.layoutAttrVo.infoList" :key="item.type">
                        <div class="box-1" v-if="index === 0 && item.val">
                            <div class="fr ac" v-if="item.type == 'SHOW_ALBUM_NAME'">
                                <div class="album-title" style="flex: 1">
                                    <p>{{ albumDetail.title }}</p>
                                    <p v-if="albumDetail.subtitle" style="font-size: 15px">{{ albumDetail.subtitle
                                        }}</p>
                                    <span v-if="debug">({{ albumDetail.id }})</span>


                                </div>
                            </div>
                            <div class="fr ac" v-else-if="item.type == 'SHOW_ACTIVE_TIME'">
                                <img :src="computedResources('icon_time.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                <div class="album-info">{{ activeDateText }}</div>
                            </div>

                            <div v-else-if="
                                    (albumDetail.activeRegion[0] !== '全国' || albumDetail.customRegion.length > 0) &&
                                    item.type == 'SHOW_ACTIVE_REGION'
                                " class="fr nowrap album-info">
                                <img :src="computedResources('icon_place.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px; object-fit: contain" />
                                <div :class="showAddress ? 'packUpAddress' : 'showAllAddress'" @click="onChangeAddress">
                                    <template v-if="albumDetail.activeRegion[0] !== '全国'">
                                        <template v-for="activeRegion in albumDetail.activeRegion" :key="activeRegion">
                                            {{ activeRegion.replace(/\空/g, '') }}
                                        </template>
                                        <br />
                                    </template>
                                    <span>
                                        {{ albumDetail?.customRegion }}
                                    </span>
                                </div>
                            </div>

                            <div class="album-info albumDesc pre-line-text" v-else-if="item.type == 'SHOW_ALBUM_DESC'">
                                {{ albumDetail.albumDesc }}
                            </div>

                            <div class="fr ac album-info" v-else-if="item.type == 'SHOW_ALBUM_VIEW_COUNT'">
                                <div class="fr ac">
                                    <img :src="computedResources('icon_browse.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{
                                        formatNumber(albumDetail.viewNum) }}</div>
                                </div>
                                <div class="fr ac">
                                    <img :src="computedResources('icon_gallery_num.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{ formatNumber(displayCount) }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-2" v-else-if="index === 1 && item.val" style="margin-top: 8px">
                            <div class="fr ac" v-if="item.type == 'SHOW_ALBUM_NAME'">
                                <div class="album-title" style="flex: 1">
                                    <p>{{ albumDetail.title }}</p>
                                    <p v-if="albumDetail.subtitle" style="font-size: 15px">{{ albumDetail.subtitle
                                        }}</p>
                                    <span v-if="debug">({{ albumDetail.id }})</span>

                                </div>
                            </div>

                            <div class="fr ac" v-else-if="item.type == 'SHOW_ACTIVE_TIME'">
                                <img :src="computedResources('icon_time.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                <div class="album-info">{{ activeDateText }}</div>
                            </div>

                            <div v-else-if="
                                    (albumDetail.activeRegion[0] !== '全国' || albumDetail.customRegion.length > 0) &&
                                    item.type == 'SHOW_ACTIVE_REGION'
                                " class="fr nowrap album-info">
                                <img :src="computedResources('icon_place.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px; object-fit: contain" />
                                <div :class="showAddress ? 'packUpAddress' : 'showAllAddress'" @click="onChangeAddress">
                                    <template v-if="albumDetail.activeRegion[0] !== '全国'">
                                        <template v-for="activeRegion in albumDetail.activeRegion" :key="activeRegion">
                                            {{ activeRegion.replace(/\空/g, '') }}
                                        </template>
                                        <br />
                                    </template>
                                    <span>
                                        {{ albumDetail?.customRegion }}
                                    </span>
                                </div>
                            </div>

                            <div class="album-info albumDesc pre-line-text" v-else-if="item.type == 'SHOW_ALBUM_DESC'">
                                {{ albumDetail.albumDesc }}
                            </div>

                            <div class="fr ac album-info" v-else-if="item.type == 'SHOW_ALBUM_VIEW_COUNT'">
                                <div class="fr ac">
                                    <img :src="computedResources('icon_browse.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{
                                        formatNumber(albumDetail.viewNum) }}</div>
                                </div>
                                <div class="fr ac">
                                    <img :src="computedResources('icon_gallery_num.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{ formatNumber(displayCount) }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-3" v-else-if="index === 2 && item.val" style="margin-top: 4px">
                            <div class="fr ac" v-if="item.type == 'SHOW_ALBUM_NAME'">
                                <div class="album-title" style="flex: 1">
                                    <p>{{ albumDetail.title }}</p>

                                    <p v-if="albumDetail.subtitle" style="font-size: 15px">{{ albumDetail.subtitle
                                        }}</p>
                                    <span v-if="debug">({{ albumDetail.id }})</span>



                                </div>
                            </div>

                            <div class="fr ac" v-else-if="item.type == 'SHOW_ACTIVE_TIME'">
                                <img :src="computedResources('icon_time.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                <div class="album-info">{{ activeDateText }}</div>
                            </div>

                            <div v-else-if="
                                    (albumDetail.activeRegion[0] !== '全国' || albumDetail.customRegion.length > 0) &&
                                    item.type == 'SHOW_ACTIVE_REGION'
                                " class="fr nowrap album-info">
                                <img :src="computedResources('icon_place.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px; object-fit: contain" />
                                <div :class="showAddress ? 'packUpAddress' : 'showAllAddress'" @click="onChangeAddress">
                                    <template v-if="albumDetail.activeRegion[0] !== '全国'">
                                        <template v-for="activeRegion in albumDetail.activeRegion" :key="activeRegion">
                                            {{ activeRegion.replace(/\空/g, '') }}
                                        </template>
                                        <br />
                                    </template>
                                    <span>
                                        {{ albumDetail?.customRegion }}
                                    </span>
                                </div>
                            </div>

                            <div class="album-info albumDesc pre-line-text" v-else-if="item.type == 'SHOW_ALBUM_DESC'">
                                {{ albumDetail.albumDesc }}
                            </div>

                            <div class="fr ac album-info" v-else-if="item.type == 'SHOW_ALBUM_VIEW_COUNT'">
                                <div class="fr ac">
                                    <img :src="computedResources('icon_browse.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{
                                        formatNumber(albumDetail.viewNum) }}</div>
                                </div>
                                <div class="fr ac">
                                    <img :src="computedResources('icon_gallery_num.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{ formatNumber(displayCount) }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-4" v-else-if="index === 3 && item.val" style="margin-top: 12px">
                            <div class="fr ac" v-if="item.type == 'SHOW_ALBUM_NAME' && item.val">
                                <div class="album-title" style="flex: 1">
                                    <p>{{ albumDetail.title }}</p>
                                    <p v-if="albumDetail.subtitle" style="font-size: 15px">{{ albumDetail.subtitle
                                        }}</p>
                                    <span v-if="debug">({{ albumDetail.id }})</span>



                                </div>
                            </div>

                            <div class="fr ac" v-else-if="item.type == 'SHOW_ACTIVE_TIME'">
                                <img :src="computedResources('icon_time.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                <div class="album-info">{{ activeDateText }}</div>
                            </div>

                            <div v-else-if="
                                    (albumDetail.activeRegion[0] !== '全国' || albumDetail.customRegion.length > 0) &&
                                    item.type == 'SHOW_ACTIVE_REGION'
                                " class="fr nowrap album-info">
                                <img :src="computedResources('icon_place.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px; object-fit: contain" />
                                <div :class="showAddress ? 'packUpAddress' : 'showAllAddress'" @click="onChangeAddress">
                                    <template v-if="albumDetail.activeRegion[0] !== '全国'">
                                        <template v-for="activeRegion in albumDetail.activeRegion" :key="activeRegion">
                                            {{ activeRegion.replace(/\空/g, '') }}
                                        </template>
                                        <br />
                                    </template>
                                    <span>
                                        {{ albumDetail?.customRegion }}
                                    </span>
                                </div>
                            </div>

                            <div class="album-info albumDesc pre-line-text" v-else-if="item.type == 'SHOW_ALBUM_DESC'">
                                {{ albumDetail.albumDesc }}
                            </div>

                            <div class="fr ac album-info" v-else-if="item.type == 'SHOW_ALBUM_VIEW_COUNT'">
                                <div class="fr ac">
                                    <img :src="computedResources('icon_browse.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{
                                        formatNumber(albumDetail.viewNum) }}</div>
                                </div>
                                <div class="fr ac">
                                    <img :src="computedResources('icon_gallery_num.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{ formatNumber(displayCount) }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-5" v-else-if="index === 4 && item.val" style="margin-top: 12px">
                            <div class="fr ac" v-if="item.type == 'SHOW_ALBUM_NAME'">
                                <div class="album-title" style="flex: 1">
                                    <p>{{ albumDetail.title }}</p>
                                    <p v-if="albumDetail.subtitle" style="font-size: 15px">{{ albumDetail.subtitle
                                        }}</p>
                                    <span v-if="debug">({{ albumDetail.id }})</span>


                                </div>
                            </div>

                            <div class="fr ac" v-else-if="item.type == 'SHOW_ACTIVE_TIME'">
                                <img :src="computedResources('icon_time.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                <div class="album-info">{{ activeDateText }}</div>
                            </div>

                            <div v-else-if="
                                    (albumDetail.activeRegion[0] !== '全国' || albumDetail.customRegion.length > 0) &&
                                    item.type == 'SHOW_ACTIVE_REGION'
                                " class="fr nowrap album-info">
                                <img :src="computedResources('icon_place.png')"
                                    style="display: block; width: 16px; height: 16px; margin-right: 4px; object-fit: contain" />
                                <div :class="showAddress ? 'packUpAddress' : 'showAllAddress'" @click="onChangeAddress">
                                    <template v-if="albumDetail.activeRegion[0] !== '全国'">
                                        <template v-for="activeRegion in albumDetail.activeRegion" :key="activeRegion">
                                            {{ activeRegion.replace(/\空/g, '') }}
                                        </template>
                                        <br />
                                    </template>
                                    <span>
                                        {{ albumDetail?.customRegion }}
                                    </span>
                                </div>
                            </div>

                            <div class="album-info albumDesc pre-line-text" v-else-if="item.type == 'SHOW_ALBUM_DESC'">
                                {{ albumDetail.albumDesc }}
                            </div>

                            <div class="fr ac album-info" v-else-if="item.type == 'SHOW_ALBUM_VIEW_COUNT'">
                                <div class="fr ac">
                                    <img :src="computedResources('icon_browse.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{
                                        formatNumber(albumDetail.viewNum) }}</div>
                                </div>
                                <div class="fr ac">
                                    <img :src="computedResources('icon_gallery_num.png')"
                                        style="display: block; width: 16px; height: 16px; margin-right: 4px" />
                                    <div class="count-color" style="margin-right: 24px">{{ formatNumber(displayCount) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="cardContainer card-container" v-if="albumDetail.brandCardList.length > 0">
                    <div class="h2-title sponsor">{{ albumDetail.cardTitle || '主办方' }}</div>
                    <div class="multipleCardBox" style="margin-top: 8px">
                        <div class="cardCell" @click="onCardDetail(index)"
                            v-for="(item, index) in albumDetail.brandCardList" :key="item.coverId">
                            <img :src="item.coverUrl" class="multipleCardCover" />
                            <div class="multipleTitle card-name">{{ item.title }}</div>
                        </div>
                    </div>
                </div>
                <div class="cardContainer homepage" v-if="albumDetail.userHomeId">
                    <div class="fr ac jsb">
                        <div class="fr ac" style="flex: 1; overflow: hidden">
                            <img :src="albumDetail.userHomeAvatar" class="appointment-avatar" />
                            <div class="fc" style="margin-left: 10px">
                                <div class="h2-title"
                                    style="width: calc(100vw - 182px); overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
                                    {{ albumDetail.userHomeNickname }}
                                </div>
                                <div class="album-info" style="font-size: 12px; margin-top: 2px">{{
                                    albumDetail.userHomeDesc }}</div>
                            </div>
                        </div>
                        <div class="appointment fr ac jc" @click="toUserHome">咨询</div>
                    </div>
                </div>
                <div class="fr ac album-cell btns-container">
                    <div class="btns" v-if="albumDetail && albumDetail.canDownload" @click="batchDownloadToast"
                        style="width: 20%">
                        <img :src="computedResources('btn_down.png')" class="album-cell-btn" />
                        <div class="album-title">{{ isEnglish?'Download':'批量下载' }}</div>
                    </div>
                    <template v-if="showFunctionContainer">
                        <template v-for="item in albumDetail.layoutAttrVo.functionList" :key="item.type">
                            <div class="btns" @click="showPluzzeToast" style="width: 20%"
                                v-if="item.type === 'OPEN_PHOTO_JIGSAW' && item.val && albumDetail.payPhotoType != 'PAY_PHOTO'">
                                <img :src="computedResources('btn_jigsaw.png')" class="album-cell-btn" />
                                <div class="album-title">{{ isEnglish?'Puzzle':'拼图' }}</div>
                            </div>
                            <div class="btns" @click="findface('findPerson')" style="width: 20%"
                                v-if="item.type === 'OPEN_PHOTO_FACE' && item.val && albumDetail.exclusiveType != 'SCHOOL'">
                                <img :src="computedResources('btn_someone.png')" class="album-cell-btn" />
                                <div class="album-title">{{ isEnglish?'Find':'找人' }}</div>
                            </div>
                            <div class="btns" @click="sharePhoto" style="width: 20%"
                                v-if="item.type === 'OPEN_ALBUM_SHARE' && item.val">
                                <img :src="computedResources('btn_share.png')" class="album-cell-btn" />
                                <div class="album-title">{{ isEnglish?'Share':'分享' }}</div>
                            </div>
                            <div class="btns" @click="handleNumberIdentify" style="width: 20%"
                                v-if="item.type === 'OPEN_NUMBER_IDENTIFY' && item.val">
                                <img :src="computedResources('icon_numberIdentify.png')" class="album-cell-btn" />
                                <div class="album-title">{{ isEnglish?'Recognize':'识别' }}</div>
                            </div>
                        </template>
                    </template>

                    <div class="btns" @click="searchFileName" style="width: 20%" v-if="albumDetail.searchPhotoName">
                        <img :src="computedResources('btn_search.png')" class="album-cell-btn" />
                        <div class="album-title">搜索</div>
                    </div>

                    <div class="btns" @click="findface('findKid')" v-if="albumDetail.exclusiveType == 'SCHOOL'"
                        style="width: 20%">
                        <img :src="computedResources('btn_someone.png')" class="album-cell-btn" />
                        <div class="album-title">找孩子</div>
                    </div>
                    <div class="btns" @click="toMyKids" v-if="showMyKids" style="width: 20%">
                        <img :src="computedResources('btn_child.png')" class="album-cell-btn" />
                        <div class="album-title">我的孩子</div>
                    </div>
                    <div class="btns"
                        v-if="tabList[currentTabIndex].id == 'photo' && albumDetail.payPhotoType == 'PAY_PHOTO'"
                        @click="startBuyPhoto" style="width: 20%">
                        <img :src="computedResources('btn_buy.png')" class="album-cell-btn" />
                        <div class="album-title">批量购买</div>
                    </div>
                </div>
            </div>
            <div class="albumPhoto album-header-container">
                <sticky :offset-top="0">
                    <div ref="tabsRef" class="tabs album-header-container">
                        <div class="fr jsb ac" style="width: 100%; padding-top: 12px; padding-bottom: 12px">
                            <div class="fr ac" style="flex: 1; overflow-x: scroll; white-space: nowrap">
                                <div v-for="(tab, index) in tabList" :key="tab.id"
                                    :class="currentTabIndex === index ? 'activeTab' : 'normalTab'"
                                    @click="onChangeTab(index)"
                                    :style="index !== tabList.length - 1 ? 'margin-right: 20px;' : ''">
                                    <div :class="currentTabIndex === index ? 'album-tab' : ''">{{ tab.title }}</div>
                                </div>
                            </div>
                            <div class="fr ac" v-if="!multipleChoseModal && tabList[currentTabIndex].id == 'photo'">
                                <popover v-model:show="showSort" :show-arrow="false" placement="bottom">
                                    <div :class="[albumStore.sortType === 'ASC' ? 'sort-item-act' : '', 'fr ac']"
                                        style="padding: 10px 12px" @click.stop="onChangeSortType('ASC')">
                                        <img :src="
                                                computedResources(
                                                    albumStore.sortType === 'ASC' ? 'iocn_sort_shoot_plus_checked.png' : 'iocn_sort_shoot_plus.png'
                                                )
                                            " class="sort-icon" />
                                        <div v-if="isEnglish"
                                            :class="[albumStore.sortType === 'ASC' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            sequential</div>
                                        <div v-else
                                            :class="[albumStore.sortType === 'ASC' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            正序</div>
                                    </div>
                                    <div :class="[albumStore.sortType === 'DESC' ? 'sort-item-act' : '', 'fr ac']"
                                        style="padding: 10px 12px" @click.stop="onChangeSortType('DESC')">
                                        <img :src="
                                                computedResources(
                                                    albumStore.sortType === 'DESC' ? 'iocn_sort_shoot_minus_checked.png' : 'iocn_sort_shoot_minus.png'
                                                )
                                            " class="sort-icon" />
                                        <div v-if="!isEnglish"
                                            :class="[albumStore.sortType === 'DESC' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            倒序</div>
                                        <div v-else
                                            :class="[albumStore.sortType === 'DESC' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            reverse</div>
                                    </div>

                                    <template #reference>
                                        <div class="fr ac" @click.stop="isshowPopover('sort')">
                                            <img :src="computedResources('frame.png')" class="sort-icon" />
                                            <div class="album-sort-title">{{ isEnglish?'Sort':'排序' }}</div>
                                        </div>
                                    </template>
                                </popover>

                                <popover v-model:show="showDisplay" :show-arrow="false" placement="bottom-end">
                                    <div :class="[displayType === 'GRID' ? 'sort-item-act' : '', 'fr ac']"
                                        style="padding: 10px 12px" @click.stop="onchangeDisplayType('GRID')">
                                        <img :src="computedResources(displayType === 'GRID' ? 'icon_grid_checked.png' : 'icon_grid.png')"
                                            class="sort-icon" />
                                        <div v-if="!isEnglish"
                                            :class="[displayType === 'GRID' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            宫格</div>
                                        <div v-else
                                            :class="[displayType === 'GRID' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            Gird</div>
                                    </div>
                                    <div :class="[displayType === 'WATERFALL_FLOW' ? 'sort-item-act' : '', 'fr ac']"
                                        style="padding: 10px 12px" @click.stop="onchangeDisplayType('WATERFALL_FLOW')">
                                        <img :src="
                                                computedResources(
                                                    displayType === 'WATERFALL_FLOW' ? 'icon_lazy_loading_checked.png' : 'icon_lazy_loading.png'
                                                )
                                            " class="sort-icon" />
                                        <div v-if="!isEnglish"
                                            :class="[displayType === 'WATERFALL_FLOW' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            瀑布流
                                        </div>
                                        <div v-else
                                            :class="[displayType === 'WATERFALL_FLOW' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            Waterfall
                                        </div>
                                    </div>
                                    <div :class="[displayType === 'TIME_LINE' ? 'sort-item-act' : '', 'fr ac']"
                                        style="padding: 10px 12px" @click.stop="onchangeDisplayType('TIME_LINE')">
                                        <img :src="computedResources(displayType === 'TIME_LINE' ? 'icon_timeline_checked.png' : 'icon_timeline.png')"
                                            class="sort-icon" />
                                        <div v-if="!isEnglish"
                                            :class="[displayType === 'TIME_LINE' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            时间线</div>
                                        <div v-else
                                            :class="[displayType === 'TIME_LINE' ? 'album-sort-active' : 'album-sort', 'sort-item']">
                                            TimeLine</div>
                                    </div>

                                    <template #reference>
                                        <div class="fr ac" @click.stop="isshowPopover('display')"
                                            style="margin-left: 14px">
                                            <img :src="computedResources('element-equal.png')" class="sort-icon" />
                                            <div class="album-sort-title">{{ isEnglish?'ShowType':'展示' }}</div>
                                        </div>
                                    </template>
                                </popover>
                            </div>
                        </div>
                        <div class="fr"
                            v-if="tabList[currentTabIndex].id == 'photo' && albumDetail.labelType !== 'NONE' && labelList.length > 0"
                            style="width: 100%; overflow-x: scroll; margin-bottom: 12px">
                            <div class="fc" v-for="label in labelList" :key="label.id"
                                style="flex: none; margin-right: 8px" @click="onChangeLabel(label.id)">
                                <div :class="label.id === albumStore.labelId ? 'album-label-active' : 'album-label'">
                                    {{ label.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </sticky>
                <div class="photo" :style="multipleChoseModal ? 'margin-bottom:60px' : ''">
                    <div v-if="tabList[currentTabIndex].id !== 'selected'">
                        <DisplayLayout ref="DisplayLayoutRef" :photoList="photoList" :debug="debug"
                            :choseEdit="multipleChoseModal" @choseItem="choseItem" :loadMore="loadMore"
                            galleryID="displayLayout" :displayType="displayType" :totalCount="totalCount"
                            :needRefresh="lightboxRefresh" @buyPhoto="buyPhoto" :pages="pages"
                            @nextPage="swiperNextPage" :albumDetail="albumDetail" @refresh-list="refreshPhotoList"
                            :photoListType="tabList[currentTabIndex].id" :repeatLike="repeatLike" />
                    </div>
                    <div v-else>
                        <div v-for="(item, index) in albumDetail.chosenInfo.list" :key="index">
                            <video v-if="item.videoUrl" ref="videoRef" class="video" playsinline :src="item.videoUrl"
                                :poster="item.coverUrl" controls />
                            <img v-else class="video" :src="item.coverUrl" />
                        </div>
                    </div>
                </div>
                <div class="footer footer-cell" v-if="albumDetail.h5BottomInfo">
                    <div>咔拍摄影提供技术支持~ v{{ version }}</div>
                </div>
            </div>
        </div>
    </template>
    <!-- 拼图样式弹窗 -->
    <ToastBottom :visible="showPluzzeModal" :height="221" :showCancelBtn="false">
        <div class="puzzleContainer">
            <div class="toast-title fr ac jfs">{{ isEnglish?'Style':'拼图样式' }}</div>
            <div class="puzzleBox">
                <div class="fc ac">
                    <div class="pluzee-item-box fc ac jc" @click="chosepuzzleMode('GIRD')">
                        <img :src="computedResources('icon_grid_checked_red.png')" class="pluzee-item-icon" />
                    </div>
                    <div class="pullze-item-text" style="margin-top: 8px; font-size: 14px">{{isEnglish?'Gird':'宫格拼接'}}</div>
                </div>
                <div class="fc ac">
                    <div class="pluzee-item-box fc ac jc" @click="chosepuzzleMode('LONG')">
                        <img :src="computedResources('icon_long_chart_checked_rad.png')" class="pluzee-item-icon" />
                    </div>
                    <div class="pullze-item-text" style="margin-top: 8px; font-size: 14px">{{ isEnglish?'Long':'长图拼接' }}</div>
                </div>
            </div>
        </div>
        <div class="bottom bottom-cancel">
            <div class="cancelBtn" @click.stop="showPluzzeToast">{{ isEnglish?'Cancel':'取消' }}</div>
        </div>
    </ToastBottom>
    <!-- 多选模式底部弹窗按钮 -->
    <MultipleChoseBottom :visible="multipleChoseModal" :album-detail="albumDetail" :chose-type="choseType"
        :chose-photo-count="chosePhotoCount" :pay-money="payMoney" :discount-money="discountMoney"
        @closeChose="closeChose" @downloadMini="downloadMini" @confirmBuy="confirmBuy('batch')"
        @confirmPluzze="confirmPluzze" />
    <!-- 开屏页面 -->
    <Screen v-if="showScreen" :albumId="albumDetail.id" :privacy="albumDetail.privacy" :url="albumDetail.shareScreenUrl"
        :loading="loading" @join="join" @forceRoute="ForceRoute" :countdown="albumDetail.countdown"
        :screenButtonDesc="albumDetail.screenButtonDesc" :screenButton="albumDetail.screenButton"
        :screenButtonPosition="albumDetail.screenButtonPosition" :screenShowType="albumDetail.screenShowType" />
    <!-- 分享相册弹窗 -->
    <ToastBottom :visible="showShareModal" :height="256" @close="sharePhoto">
        <div class="shareContainer">
            <div class="toast-title fr ac jfs">海报样式</div>
            <div class="shareBox">
                <div class="fc ac">
                    <div class="pluzee-item-box fc ac jc" @click="chosePoster('POSTER_1')">
                        <img :src="computedResources('image1_rad.png')" class="pluzee-item-icon" />
                    </div>
                    <div class="pullze-item-text" style="margin-top: 4px">海报1</div>
                </div>
                <div class="fc ac">
                    <div class="pluzee-item-box fc ac jc" @click="chosePoster('POSTER_2')">
                        <img :src="computedResources('image2_rad.png')" class="pluzee-item-icon" />
                    </div>
                    <div class="pullze-item-text" style="margin-top: 4px">海报2</div>
                </div>
            </div>
        </div>
    </ToastBottom>
    <!-- 卡片弹窗 -->
    <ToastBottom :visible="showCardDetail" :show-cancel-btn="false" @close="onCardDetail">
        <div class="cardContainer">
            <div class="fr ac">
                <img :src="cardDetail.coverUrl" class="cover" @click.stop="previewCardCover" />
                <div class="taost-card-name">{{ cardDetail.title }}</div>
            </div>
            <div class="space-line" />
            <div v-if="cardDetail.attachPhotoList.length > 0" style="width: 100%">
                <div class="h2-title">图片介绍</div>
                <div class="cardPhotoCantainer">
                    <img v-for="(item, index) in cardDetail.attachPhotoList" :key="item.photoId" :src="item.photoUrl"
                        class="cardPhoto" @click="previewCardPhoto(index)" />
                </div>
                <div class="space-line" />
            </div>
            <div v-if="cardDetail.urlDataList.length > 0" style="width: 100%">
                <div class="h2-title">相关链接</div>
                <div class="urlData">
                    <div class="urlDataCell" v-for="item in cardDetail.urlDataList" :key="item.url">
                        <div v-if="item.desc || item.url" @click="toCardUrl(item.url)"
                            class="urlDetail taost-card-link">
                            {{ item.desc ? item.desc : item.url }}
                        </div>
                    </div>
                </div>
                <div class="space-line" />
            </div>
            <div class="descText taost-card-desc">{{ cardDetail.desc }}</div>
        </div>
    </ToastBottom>

    <image-preview v-model:show="showCardPhotoVisible" :images="cardImages" closeable show-index
        :start-position="startPosition">
        <template #image="{src}">
            <img :src="src" style="width: 100%; z-index: 999999" @click.prevent="longppress" />
            <div v-if="!RNPostData" class="cardtips">tips:长按即可保存图片到手机</div>
        </template>
    </image-preview>

    <!-- 购买照片弹窗-->
    <BuyToast :buyToast="buyToast" :buyPhotoInfo="buyPhotoInfo" :albumDetail="albumDetail" @close="buyToast = false"
        @buy="confirmBuy('single')" />

    <!-- 同意隐私政策弹窗-->
    <div v-if="agreenToast" class="toaskMask" @touchmove.prevent>
        <div class="agreenModal">
            <div class="agreen-title">用戶隐私保护提示</div>
            <div class="buy-content">
                <div>
                    感谢您使用本相册，使用前应当阅读并同意
                    <a href="https://h5.kapaisy.com/doc/agreement/agreement.html" style="color: #2d94ed">《用户隐私政策》</a>
                    。当您点击同意后，即表示您已理解并同意该条款内容，该条款将对您产生法律约束力。如您拒绝，将无法使用该服务。
                </div>
                <div class="agreen-btn">
                    <div class="agreen-cancel" @click="agreen('cancel')">拒绝</div>
                    <div class="agreen-confirm" @click="agreen('confrim')">同意</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 批量下载小程序码 -->
    <ToastBottom :visible="batchDownloadVisible" :height="272" @close="showBatchPhoto">
        <div
            style="display: flex; flex-direction: column; align-items: center; justify-content: center; margin-top: 24px">
            <div>长按识别小程序码下载照片</div>
            <img :src="'data:image/jpg;base64,' + qrCode"
                style="width: 136px; height: 136px; margin-top: 16px; margin-bottom: 24px" />
        </div>
    </ToastBottom>

    <!-- 批量下载打开温馨-->
    <div v-if="modalName == 'openWechat'" class="toaskMask" @touchmove.prevent>
        <div class="agreenModal">
            <div class="buy-content">
                <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
                    <img src="../assets/images/wechat.png" style="width:54px;height:54px" />
                    <div style="color:#22242C;font-size: 14px;margin-top: 16px;">{{isEnglish?"To download images, please open them in WeChat":'如需下载图片, 请在微信中打开'}}</div>
                    <div class="toast-chose-btn confirmBtn" @click="hideModal">{{isEnglish?'Confirm':'确定'}}</div>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import {defineComponent, onMounted, onUpdated, reactive, ref, toRefs, onDeactivated, watchEffect, onActivated, onBeforeUnmount, onBeforeMount} from 'vue'
import {
    useDataPoint,
    hotPhotoList,
    useGetAlbumDetail,
    useGetAlbumLabelList,
    useGetAlbumList,
    useGetWatermark,
    useAlbumAttr,
    createBuyPhotoOrder,
    buyPhotoList,
    downloadMiniCode,
    getNowAlbumNum,
    voteList
} from './api'
import type {
    AlbumDetailProps,
    AlbumPhotoFaceProps,
    AlbumPhotoSortBy,
    AttrMultiWatermark,
    CradItem,
    DisplayType,
    LabelDetailProps,
    PhotoListParam,
    PhotoOutlineProps,
    RequestPhotoOutlineProps,
    SortType,
    ThemeData
} from '@/views/props'
import Banner from '@/components/Banner.vue'
import BuyToast from '@/components/BuyToast.vue'
import MultipleChoseBottom from '@/components/MultipleChoseBottom.vue'
import DisplayLayout from '../components/DisplayLayout.vue'
import {useRouter} from 'vue-router'
import ToastBottom from '../components/ToastBottom.vue'
import Screen from '../components/Screen.vue'
import {useAlbumStore} from '@/store/album'
import {buildPhotoUrl} from '@/utils/buildPhotoUrls'
import Cookies from 'js-cookie'
import {throttle,debounce, computedResources, formatNumber, getIsWxClient} from '@/utils'
import {useThemeStore} from '@/store/theme'
import {useTabbarStore} from '@/store/tabbar'
import config from '@/config'
import {showNotify} from 'vant/lib/notify'
import {ImagePreview, showImagePreview, Popover, Sticky, Divider} from 'vant'
import {readyWxPay} from '@/utils/wxPay'
export type PuzzleMode = 'LONG' | 'LIST' | 'GIRD'

interface Props {
    tabList: {id: string; title: string}[]
    albumDetail: AlbumDetailProps
    displayType: DisplayType
    // sortType: SortType
    currentTabIndex: number
    currentIndex: number
    isTop: boolean
    headerHeight: number
    loadMore: boolean
    totalCount: number
    displayCount: number
    labelList: LabelDetailProps[]
    loading: boolean
    watermarkList: AttrMultiWatermark[]
    shareScreen: {
        customizedScreenId: string
        customizedScreenUrl: string
        screenId: string
        screenTxt: string
        screenUrl: string
        screenType: 'CUSTOMIZED' | 'SYSTEM' | 'FORBADE'
    } | null
    pages: number
    personList: AlbumPhotoFaceProps[]
    photoVisible: boolean
    mainLoading: boolean
    isEnding: boolean
    nextList: PhotoOutlineProps[]
    downloadSuccess: boolean
    showAddress: boolean
    theme: ThemeData
    showPluzzeModal: boolean
    puzzleMode: PuzzleMode
    multipleChoseModal: boolean
    chosePhotoCount: number
    debug: boolean
    topIndex: number
    activeDateText: string
    showShareModal: boolean
    showCardDetail: boolean
    cardDetail: CradItem
    lightboxRefresh: boolean
    showDisplay: boolean
    showSort: boolean

    showCardPhotoVisible: boolean
    startPosition: number
    cardImages: string[]
    labelClickCount: number
    version: string
    // displayOtherLabel: boolean
    // displayAllLabel: boolean
    showMyKids: boolean
    loadingUrl: string
    loadingSize: number

    showFunctionContainer: boolean
    showInfoContainer: boolean

    choseType: 'PUZZLE' | 'BUY' | 'DOWNLOAD'
    buyToast: boolean
    buyPhotoInfo: PhotoOutlineProps
    photoLoading: boolean
    agreenToast: boolean
    albumId: string
    payMoney: number
    discountMoney: number
    batchDownloadVisible: boolean
    isWechatPlatform: boolean
    qrCode: string
    repeatLike: true
    updatePhotoListTimer: any
    updatePhotoListFlag: boolean
    lastUpdatePhotoCount: number
    modalName: string
    vote:boolean
    isEnglish:boolean
}

export default defineComponent({
    components: {
        Banner,
        DisplayLayout,
        ToastBottom,
        Screen,
        Popover,
        Sticky,
        ImagePreview,
        Divider,
        BuyToast,
        MultipleChoseBottom
    },
    setup() {
        const RNPostData = localStorage.getItem('RNPostData')
        const router = useRouter()
        const albumStore = useAlbumStore()
        const themeStore = useThemeStore()
        const tabbarStore = useTabbarStore()
        const tabsRef = ref()
        const showScreen = ref(false)
        const DisplayLayoutRef = ref()
        const photoList = ref<PhotoOutlineProps[]>([])
        const {albumId} = albumStore
        let offsetTop = 0
        const state = reactive<Props>({
            albumId,
            tabList: albumStore.albumId_en.includes(albumId)?[{ id: 'photo', title: 'Photos' }]:[{ id: 'photo', title: '照片' }],
            albumDetail: undefined,
            displayType: 'WATERFALL_FLOW',
            currentTabIndex: 0,
            currentIndex: 0,
            isTop: false,
            headerHeight: 0,
            loadMore: true,
            totalCount: 0,
            displayCount: 0,
            labelList: [],
            loading: true,
            watermarkList: [],
            shareScreen: null,
            pages: 0,
            personList: [],
            photoVisible: false,
            mainLoading: true,
            isEnding: false,
            nextList: [],
            downloadSuccess: false,
            showAddress: false,
            theme: themeStore.theme,
            showPluzzeModal: albumStore.puzzle,
            puzzleMode: 'LONG',
            multipleChoseModal: false,
            chosePhotoCount: 0,
            debug: albumStore.debug,
            topIndex: 0,
            activeDateText: '',
            showShareModal: albumStore.sharePoster,
            showCardDetail: false,
            cardDetail: null,
            lightboxRefresh: false,

            showDisplay: false,
            showSort: false,
            showCardPhotoVisible: false,
            startPosition: 0,
            cardImages: [],
            labelClickCount: 0,
            version: config.EVN.versionName,
            showMyKids: false,
            loadingUrl: albumStore.loadingUrl,
            loadingSize: albumStore.loadingSize,
            showFunctionContainer: true,
            showInfoContainer: true,
            choseType: 'PUZZLE',
            buyToast: false,
            buyPhotoInfo: null,
            photoLoading: false,
            agreenToast: false,
            payMoney: 0.0,
            discountMoney: 0,
            batchDownloadVisible: false,
            isWechatPlatform: getIsWxClient(),
            qrCode: '',
            repeatLike: true,
            updatePhotoListTimer: null,
            updatePhotoListFlag: false,
            lastUpdatePhotoCount:0,
            modalName: '',
            vote:false,
            isEnglish:albumStore.albumId_en.includes(albumId),
        })

        const isScrollListenerRegistered = ref(false)
        const checkedList = ref<PhotoOutlineProps[]>([])
        // 初始化请求
        onMounted(() => {
            // window.addEventListener('scroll', throttle(handleScroll), false)
            state.pages = 0
            const interval = setInterval(() => {
                if (themeStore.theme.skinType && Cookies.get('albumToken')) {
                    // 获取相册属性
                    // handleGetInteract()
                    getAlbumAttr()
                    getAlbumDetail()
                    // 启动埋点数据
                    addDataPoint()
                    state.loading = false
                    clearInterval(interval)
                }
            }, 1000)
            handleGetPublishPhotoNum()
            // handleStartNumTimer()
        })

        onUpdated(() => {
            const header = document.getElementById('header')
            state.headerHeight = header?.getBoundingClientRect().height || 0
        })

        onDeactivated(() => {
            console.log('销毁album的scroll事件 onDeactivated')
            window.removeEventListener('scroll', throttle(handleScroll), false)
            window.removeEventListener('resize', handleResizeRefresh, false)
            handleCloseNumTimer()
            // 离开单个相册时隐藏底部 tab
            tabbarStore.hide()
        })

        onBeforeUnmount(() => {
            console.log('销毁album的scroll事件 onBeforeUnmount')
            window.removeEventListener('scroll', throttle(handleScroll), false)
            window.removeEventListener('resize', handleResizeRefresh,false)
        })

        onActivated(() => {
            // 从相册集进入单个相册时显示底部 tab
            if (sessionStorage.getItem('tabbarFromGather') === '1') {
                tabbarStore.show()
            }
            window.addEventListener('resize', handleResizeRefresh)
            handleStartNumTimer()
            if (localStorage.getItem('kidResult')) {
                let kidResult = JSON.parse(localStorage.getItem('kidResult'))
                if (kidResult.albumId == albumId) {
                    state.showMyKids = true
                }
            }
        })

        const handleResizeRefresh = debounce((e) => {
            // 监听页面大小变化，刷新页面，展示albumview 或 albumviewweb
            if (e.target.innerWidth > 1200) {
                history.go(0)
            }
            // console.log('resize',e.target.innerWidth)
        },200)

        // 获取相册内已经购买的照片
        const getBuyPhoto = () => {
            state.photoLoading = true
            let params = {
                albumId,
                page: state.pages,
                pageSize: albumStore.pageSize,
                openId: albumStore.openId
            }
            buyPhotoList(params).then(data => {
                if (data.list) {
                    if (data.list.length === 0) {
                        console.log('改变loadmore')
                        state.loadMore = false
                    }
                    state.totalCount = data.count
                    let originList: string[] = []
                    if (JSON.parse(sessionStorage.getItem('originList')) !== null) {
                        originList = JSON.parse(sessionStorage.getItem('originList'))
                    }
                    data.list &&
                        data.list.forEach((item: PhotoOutlineProps) => {
                            const clone = buildPhotoUrl(item, state.albumDetail.photoViewType == 'WATERMARK' ? [] : state.watermarkList)
                            item.photoUrlOutline = clone.outLineUrl
                            item.photoUrlDetail = clone.detailUrl
                            item.photoUrlOrigin = clone.originUrl
                            item.photoUrlDownload = clone.downloadUrl
                            item.src = originList.includes(item.photoId) ? clone.originUrl : clone.outLineUrl
                            // item.src = clone.outLineUrl
                            item.width =
                                item.releaseType == 'MANUAL'
                                    ? item.manualWidth
                                    : item.releaseType == 'BEAUTIFUL'
                                    ? item.beautifulWidth
                                    : item.compressedWidth
                            item.height =
                                item.releaseType == 'MANUAL'
                                    ? item.manualHeight
                                    : item.releaseType == 'BEAUTIFUL'
                                    ? item.beautifulHeight
                                    : item.compressedHeight
                            item.from = 'BUY'
                        })
                    state.downloadSuccess = true
                    photoList.value.push(...data.list)
                    state.photoLoading = false
                } else {
                    state.loadMore = false
                }
            })
        }

        // 获取热门照片列表
        const getHotPhotoList = () => {
            state.photoLoading = true
            let params = {
                albumId,
                page: state.pages,
                pageSize: albumStore.pageSize
            }
            hotPhotoList(params).then(data => {
                if (data.list) {
                    if (data.list.length === 0) {
                        console.log('改变loadmore')
                        state.loadMore = false
                    }
                    state.totalCount = data.count
                    let originList: string[] = []
                    if (JSON.parse(sessionStorage.getItem('originList')) !== null) {
                        originList = JSON.parse(sessionStorage.getItem('originList'))
                    }
                    data.list &&
                        data.list.forEach((item: PhotoOutlineProps) => {
                            const clone = buildPhotoUrl(item, state.albumDetail.photoViewType == 'WATERMARK' ? [] : state.watermarkList)
                            item.photoUrlOutline = clone.outLineUrl
                            item.photoUrlDetail = clone.detailUrl
                            item.photoUrlOrigin = clone.originUrl
                            item.photoUrlDownload = clone.downloadUrl
                            item.src = originList.includes(item.photoId) ? clone.originUrl : clone.detailUrl
                            item.width =
                                item.releaseType == 'MANUAL'
                                    ? item.manualWidth
                                    : item.releaseType == 'BEAUTIFUL'
                                    ? item.beautifulWidth
                                    : item.compressedWidth
                            item.height =
                                item.releaseType == 'MANUAL'
                                    ? item.manualHeight
                                    : item.releaseType == 'BEAUTIFUL'
                                    ? item.beautifulHeight
                                    : item.compressedHeight
                            item.from = 'BUY'
                        })
                    state.downloadSuccess = true
                    photoList.value.push(...data.list)
                    state.photoLoading = false
                    state.isEnding = false
                } else {
                    state.loadMore = false
                }
            })
        }

        // 获取投票排行榜
        const getVotePhotoList = () => {
            state.photoLoading = true
            let params = {
                albumId,
                page: state.pages,
                size: albumStore.pageSize,
                openId: albumStore.openId
            }
            voteList(params).then(data => {
                if (data.list) {
                    if (data.list.length < albumStore.pageSize ) {
                        console.log('改变loadmore')
                        state.loadMore = false
                    }
                    state.totalCount = data.count
                    let originList: string[] = []
                    if (JSON.parse(sessionStorage.getItem('originList')) !== null) {
                        originList = JSON.parse(sessionStorage.getItem('originList'))
                    }
                    data.list &&
                        data.list.forEach((item: PhotoOutlineProps) => {
                            const clone = buildPhotoUrl(item, state.albumDetail.photoViewType == 'WATERMARK' ? [] : state.watermarkList)
                            item.photoUrlOutline = clone.outLineUrl
                            item.photoUrlDetail = clone.detailUrl
                            item.photoUrlOrigin = clone.originUrl
                            item.photoUrlDownload = clone.downloadUrl
                            item.src = originList.includes(item.photoId) ? clone.originUrl : clone.outLineUrl
                            // item.src = clone.outLineUrl
                            item.width =
                                item.releaseType == 'MANUAL'
                                    ? item.manualWidth
                                    : item.releaseType == 'BEAUTIFUL'
                                    ? item.beautifulWidth
                                    : item.compressedWidth
                            item.height =
                                item.releaseType == 'MANUAL'
                                    ? item.manualHeight
                                    : item.releaseType == 'BEAUTIFUL'
                                    ? item.beautifulHeight
                                    : item.compressedHeight
                            item.from = 'BUY'
                        })
                    state.downloadSuccess = true
                    photoList.value.push(...data.list)
                    state.photoLoading = false
                    state.isEnding = false
                } else {
                    state.loadMore = false
                }
            })
        }
        const addDataPoint = async () => {
            const data = {
                type: 'CLICK_ALBUM',
                data: JSON.stringify({
                    albumId: albumStore.albumId,
                    uuid: Cookies.get('uuid')
                })
            }
            await useDataPoint(data)
        }

        const getWatermarkParams = async (labelId: number) => {
            const res = await useGetWatermark({albumId: albumStore.albumId, labelId: labelId || albumStore.labelId})
            state.watermarkList = res.list
            albumStore.albumWatermark = state.watermarkList
            getNextPagePhoto()
        }

        const handleScroll = () => {
            console.log('====== 监听滚动 ======')
            // title 吸顶效果
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            // if(scrollTop)
            if (scrollTop - state.headerHeight >= 50) {
                state.isTop = true
            } else {
                state.isTop = false
            }

            // 下拉加载
            // 总高度
            const scrollHeight: number = document.getElementById('context')?.clientHeight || 0
            // 可见高度
            const windowHeight = window.innerHeight
            // 可滚动超出当前窗口高度
            if (scrollTop + 10 >= scrollHeight - windowHeight && scrollTop > 0 && scrollHeight > 0) {
                // console.log("window.innerHeight ... " + window.innerHeight)
                // alert(`高度:${scrollTop}---${scrollHeight}---${windowHeight}`)
                // console.log('===== 触发加载 =======')
                nextPage()
            }

            refreshCurIndex()
        }

        const refreshCurIndex = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            offsetTop = scrollTop - state.headerHeight - 50
            const itemClass =
                state.displayType === 'WATERFALL_FLOW' ? '.masonryItem' : state.displayType === 'GRID' ? '.imgWapper' : '.timelineImgWapper'
            const masonryItems = Array.from(document.querySelectorAll<HTMLElement>(itemClass))
            // console.log(masonryItems)
            for (let i = 0; i < masonryItems.length; i++) {
                // console.log('find top element ', masonryItems[i].offsetTop, (scrollTop- state.headerHeight))
                if (masonryItems[i].offsetTop + masonryItems[i].clientHeight >= offsetTop) {
                    // console.log('find it in ', i, masonryItems[i].offsetTop)
                    state.topIndex = i + 1
                    break
                }
            }
        }

        const swiperNextPage = page => {
            state.pages = page
        }

        const nextPage = () => {
            // console.log('nextPage ===>',state.loadMore,state.isEnding)
            // 如果下一页没有数据，则不请求
            if (!state.loadMore || state.isEnding) return
            // 设置为触底状态
            state.isEnding = true
            // 请求下一页数据
            state.pages = state.pages + 1
            if (state.tabList[state.currentTabIndex].id === 'photo') {
                getNextPagePhoto()
            } else if (state.tabList[state.currentTabIndex].id === 'buy') {
                getBuyPhoto()
            } else if (state.tabList[state.currentTabIndex].id === 'hot') {
                getHotPhotoList()
            } else if (state.tabList[state.currentTabIndex].id === 'vote') {
                getVotePhotoList()                
            }
        }

        const onChangeTab = (index: number) => {
            state.currentTabIndex = index
            state.loadMore = true
            state.pages = 0
            state.personList = []
            albumStore.personList = []
            photoList.value = []
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
            if (state.tabList[index].id === 'photo') {
                state.displayType = state.albumDetail.displayType
                if (localStorage.getItem('sortType')) {
                    albumStore.sortType = localStorage.getItem('sortType') as SortType
                }
                getNextPagePhoto()
            } else if (state.tabList[index].id === 'buy') {
                getBuyPhoto()
            } else if (state.tabList[index].id === 'hot') {
                state.displayType = 'WATERFALL_FLOW'
                getHotPhotoList()
                state.multipleChoseModal = false
            } else if (state.tabList[index].id === 'selected') {
                // getAlbumPersonList()
            } else if (state.tabList[index].id === 'vote') {
                // console.log('vote')
                state.displayType = 'WATERFALL_FLOW'
                getVotePhotoList()
            }
        }

        const onChangeLabel = (id: number) => {
            window.scrollTo({top: 0})
            state.multipleChoseModal = false
            state.labelClickCount++
            albumStore.labelId = id
            state.loadMore = true
            state.pages = 0
            photoList.value = []
            state.lightboxRefresh = true
            // console.log('635 ==>',checkedList.value)
            checkedList.value = []
            state.chosePhotoCount = 0
            getWatermarkParams(id)
        }

        const refreshPhotoList = () => {
            window.scrollTo({top: 0})
            state.multipleChoseModal = false
            state.loadMore = true
            state.pages = 0
            photoList.value = []
            checkedList.value = []
            state.chosePhotoCount = 0
            getNextPagePhoto()
        }

        // TODO
        const scrollToTop = () => {
            window.scrollTo({top: 0, behavior: 'smooth'})
        }

        const request = async () => {
            // 获取相册里列表接口参数
            const params: PhotoListParam = {
                albumId,
                labelId: albumStore.labelId,
                page: state.pages,
                pageSize: albumStore.pageSize,
                sortType: albumStore.sortType,
                photoStatus: 'PUBLISHED',
                openId: albumStore.openId
            }
            const labelClickCountMark = state.labelClickCount
            return new Promise(async (resolve, reject) => {
                useGetAlbumList(params)
                    .then(async (data: RequestPhotoOutlineProps) => {
                        if (data) {
                            if (data.list.length < 50) {
                                console.log('改变loadmore')
                                state.loadMore = false
                            }
                            state.totalCount = data.count
                            state.displayCount = data?.displayCount || 0
                            data.list.forEach((item: PhotoOutlineProps) => {
                                const clone = buildPhotoUrl(
                                    item,
                                    state.albumDetail.payPhotoType == 'PAY_PHOTO' && state.albumDetail.photoViewType == 'WATERMARK' && item.payPhoto
                                        ? []
                                        : state.watermarkList
                                )
                                item.photoUrlOutline = clone.outLineUrl
                                item.photoUrlDetail = clone.detailUrl
                                item.photoUrlOrigin = clone.originUrl
                                item.photoUrlDownload = clone.downloadUrl
                                // item.src = clone.detailUrl
                                item.src = clone.outLineUrl
                                item.width =
                                    item.releaseType == 'MANUAL'
                                        ? item.manualWidth
                                        : item.releaseType == 'BEAUTIFUL'
                                        ? item.beautifulWidth
                                        : item.compressedWidth
                                item.height =
                                    item.releaseType == 'MANUAL'
                                        ? item.manualHeight
                                        : item.releaseType == 'BEAUTIFUL'
                                        ? item.beautifulHeight
                                        : item.compressedHeight
                                item.from = 'ALBUM'
                            })
                            resolve(data)
                        } else {
                            state.isEnding = false
                        }
                    })
                    .catch(() => {
                        state.isEnding = false
                    }).finally(()=>{
                        if(!isScrollListenerRegistered.value){
                            window.addEventListener('scroll', throttle(handleScroll), false)
                            isScrollListenerRegistered.value = true
                        }
                    })
            })
        }
        // 获取相册列表
        const getNextPagePhoto = () => {
            console.log('当前相册albumId', albumId)
            if (!albumId) {
                return
            }
            request().then((data: RequestPhotoOutlineProps) => {
                if (data) {
                    // if (state.isEnding || state.pages === 0) {
                    photoList.value.push(...data.list)
                    state.isEnding = false
                    console.log('挂载下一页数据', albumStore.labelId, state.pages, state.nextList.length)
                    // }
                    if (checkedList.value.length > 0) {
                        photoList.value.forEach(item => {
                            const idx = checkedList.value.findIndex(el => el.photoId === item.photoId)
                            if (idx !== -1) {
                                item.isChecked = true
                            } else {
                                item.isChecked = false
                            }
                        })
                    }
                }
            })
        }
        const getAlbumLabelList = async () => {
            const data = await useGetAlbumLabelList({
                albumId,
                backRetouch: false,
                photoStatus: 'PUBLISHED'
            })
            // console.log('942 ===>', data)
            if (data && data.length >= 1) {
                // console.log('944==>', state.displayAllLabel,state.displayOtherLabel)
                state.labelList = data
                albumStore.labelId = data[0].id
            } else {
                albumStore.labelId = 0
            }
            getWatermarkParams(0)
        }

        const onchangeDisplayType = (type: DisplayType) => {
            // displayTypeVisible.value = false
            state.showDisplay = false
            state.displayType = type
            window.scrollTo({top: 0})
        }

        const onChangeSortType = (sortType: SortType) => {
            if (sortType !== albumStore.sortType) {
                albumStore.sortType = sortType
                state.pages = 0
                photoList.value = []
                albumStore.photoList = []
                state.loadMore = true
                state.lightboxRefresh = true
                window.scrollTo({top: 0})
                getNextPagePhoto()
            }
            if (state.tabList[state.currentTabIndex].id == 'photo') {
                localStorage.setItem('sortType', sortType)
            }
            state.showSort = false
        }

        // 函数 state.albumDetail.layoutAttrVo.functionList数据中 有一个为true就返回rue

        // 获取相册详情
        const getAlbumDetail = async () => {
            try {
                let res = await useGetAlbumDetail({ albumId })
                if (res) {
                document.title = res.sharePageTitle || res.title
                state.albumDetail = res
                albumStore.forceModeDesc = res.forceModeDesc
                albumStore.forceMode = res.forceMode
                state.showFunctionContainer = state.albumDetail.layoutAttrVo.functionList.some(item => item.val == true)
                state.showInfoContainer = state.albumDetail.layoutAttrVo.infoList.some(item => item.val == true)
                if (state.albumDetail.shareScreenUrl) {
                    showScreen.value = true
                }
                albumStore.sortType = state.albumDetail.sortType
                albumStore.downPhotoQuality = state.albumDetail.downPhotoQuality

                state.theme = themeStore.theme
                state.displayType = state.albumDetail.displayType
                state.mainLoading = false
                state.agreenToast = res.h5PrivacyOpen
                if (res.chosenInfo?.open && res.chosenInfo?.list.length > 0) {
                    state.tabList.push({ id: 'selected', title: res.chosenInfo?.title || '精选' })
                }
                if (res.payPhotoType == 'PAY_PHOTO') {
                    state.tabList.push({ id: 'buy', title: '已购' })
                }
                if (res.albumHot && res.payPhotoType != 'PAY_PHOTO') {
                    state.tabList.push({ id: 'hot', title: '热门' })
                }
                getAlbumLabelList()
                getShowDateText()
                handleGetInteract()
                }  
            } catch (error) {

            }    
        }

        const getShowDateText = () => {
            if (state.albumDetail) {
                const {activeBeginDate, activeEndDate} = state.albumDetail
                const start = new Date(activeBeginDate.replace(/\-/g, '/'))
                const end = new Date(activeEndDate.replace(/\-/g, '/'))
                const isSameDay = activeBeginDate.split(' ')[0] == activeEndDate.split(' ')[0]
                const date1Text =
                    start.getFullYear() == new Date().getFullYear()
                        ? activeBeginDate.slice(5, activeBeginDate.length)
                        : activeBeginDate.replace(/\-/g, '.')
                const date1Day = date1Text.split(' ')[0].replace(/\-/g, '/').replace(/\./g, '/')
                const date1Time = date1Text.split(' ')[1]
                const date2Text =
                    end.getFullYear() == new Date().getFullYear() ? activeEndDate.slice(5, activeEndDate.length) : activeEndDate.replace(/\-/g, '.')
                const date2Day = date2Text.split(' ')[0].replace(/\-/g, '/').replace(/\./g, '/')
                const date2Time = date2Text.split(' ')[1]
                state.activeDateText = isSameDay
                    ? `${date1Day} ${date1Time === '00:00' ? '' : date1Time} ${date1Time !== '00:00' && date2Time !== '23:59' ? '--' : ''} ${
                        date2Time === '23:59' ? '' : date2Time
                    }`
                    : `${date1Day} ${date1Time === '00:00' ? '' : date1Time} -- ${date2Day} ${date2Time === '23:59' ? '' : date2Time}`
            }
        }
        const onChangeAddress = () => {
            state.showAddress = !state.showAddress
        }

        const clickPerson = (personId: string) => {
            router.push({
                name: 'albumFace',
                query: {personId}
            })
        }

        const close = () => {
            // displayTypeVisible.value = false
        }

        const join = () => {
            showScreen.value = false
        }

        const closeModal = () => {
            state.photoVisible = false
        }

        const showPluzzeToast = () => {
            state.showPluzzeModal = !state.showPluzzeModal
        }
        const showBatchPhoto = () => {
            state.batchDownloadVisible = !state.batchDownloadVisible
        }
        const chosepuzzleMode = mode => {
            if (state.tabList[state.currentTabIndex].id == 'hot') {
                onChangeTab(0)
            }
            closeChose()
            state.puzzleMode = mode
            state.showPluzzeModal = false
            state.multipleChoseModal = true
            state.choseType = 'PUZZLE'
        }
        const startBuyPhoto = () => {
            state.multipleChoseModal = true
            state.choseType = 'BUY'
        }
        const closeChose = () => {
            state.multipleChoseModal = false
            state.chosePhotoCount = 0
            state.discountMoney = 0
            state.payMoney = 0
            checkedList.value = []
            photoList.value.forEach(item => {
                item.isChecked = false
            })
        }
        const choseItem = (id: number) => {
            const idx = photoList.value.findIndex(item => item.photoId == id)
            if (state.chosePhotoCount >= 9 && !photoList.value[idx].isChecked && state.choseType === 'PUZZLE') {
                showNotify({type: 'warning', message: '最多只能选9张照片~'})
            } else {
                photoList.value[idx].isChecked = !photoList.value[idx].isChecked
                if (photoList.value[idx].isChecked) {
                    checkedList.value.push(photoList.value[idx])
                } else {
                    checkedList.value.splice(
                        checkedList.value.findIndex(item => item.photoId == id),
                        1
                    )
                }
                state.chosePhotoCount = checkedList.value.length
                state.payMoney = state.chosePhotoCount * Number(state.albumDetail.photoPrice)
                if (state.albumDetail.discount) {
                    if (state.chosePhotoCount >= state.albumDetail.discountPhotoCount) {
                        state.payMoney = Number(
                            ((state.chosePhotoCount * Number(state.albumDetail.photoPrice) * state.albumDetail.discountProportion) / 100).toFixed(2)
                        )
                        state.discountMoney = Number((state.chosePhotoCount * Number(state.albumDetail.photoPrice) - state.payMoney).toFixed(2))
                    } else {
                        state.discountMoney = 0
                    }
                }
            }
        }
        const confirmPluzze = () => {
            if (state.chosePhotoCount == 0) {
                showNotify({type: 'warning', message: '请至少选择一张照片~'})
            } else {
                const temp = JSON.parse(JSON.stringify(checkedList.value))
                const puzzleList = temp.map(item => {
                    return {
                        photoId: item.photoId,
                        photoUrlDetail: item.photoUrlDetail
                    }
                })
                if (state.puzzleMode === 'GIRD') {
                    if (puzzleList.length % 3 !== 0) {
                        showNotify({type: 'warning', message: '请选择3张/6张/9张图片！'})
                        return
                    }
                }
                // console.log('待拼图的列表：',puzzleList)
                // localStorage.setItem('puzzleList', JSON.stringify(puzzleList))
                router.replace({ path: '/puzzle', query: { type: state.puzzleMode, list: JSON.stringify(puzzleList) }})
            }
        }
        // 批量购买照片
        const confirmBuy = type => {
            if (!state.isWechatPlatform) {
                router.push('/openWechat')
            }
            if (state.chosePhotoCount == 0 && type == 'batch') {
                showNotify({type: 'warning', message: '请至少选择一张照片~'})
            } else {
                const buyList = JSON.parse(JSON.stringify(checkedList.value))
                let params = {
                    albumId: state.albumDetail.id,
                    openId: albumStore.openId,
                    photoIdList: type == 'batch' ? buyList.map(i => i.photoId) : [state.buyPhotoInfo.photoId]
                }
                readyWxPay(params, res => {
                    state.buyToast = false
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                        refreshPhotoList()
                        //支付成功后的操作
                    } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                        //取消支付的操作
                        //取消支付
                    } else {
                        //支付失败
                    }
                })
            }
        }

        const findface = type => {
            router.push({path: '/searchFace', query: {type}})
        }
        const handleNumberIdentify = () => {
            // 跳转号码识别
            router.push({path: '/numberIdentify'})
        }
        const sharePhoto = () => {
            // state.showShareModal = !state.showShareModal
            chosePoster('POSTER_4')
        }

        const chosePoster = type => {
            state.showShareModal = false
            const photoUrl = state.albumDetail.bannerShareUrl

                // state.albumDetail.banner.bannerType === 'PHOTO'
                //     ? state.albumDetail.banner.bannerPhotoList[0].photoUrl
                //     : state.albumDetail.banner.bannerVideo.coverUrl

            console.log('photoUrl==>', photoUrl)
            const shareParasm = {
                photoUrl,
                type
            }
            // console.log('shareParasm==>', shareParasm)
            localStorage.setItem('sharePosterParasm', JSON.stringify(shareParasm))
            router.push(`/sharePoster?source=albumview-btn`)
        }

        const onCardDetail = (index: number) => {
            state.cardDetail = state.albumDetail.brandCardList[index]
            state.showCardDetail = !state.showCardDetail
        }
        const previewCardPhoto = (index: number) => {
            const images = []
            state.cardDetail.attachPhotoList.forEach(item => {
                images.push(item.photoUrl)
            })
            state.showCardPhotoVisible = true
            state.startPosition = index
            state.cardImages = images
        }
        const toCardUrl = (url: string) => {
            if (url.includes('http')) {
                window.open(url)
            } else {
                window.open(window.location.protocol + '//' + url)
            }
        }
        const isshowPopover = type => {
            switch (type) {
                case 'display':
                    state.showDisplay = !state.showDisplay
                    break
                case 'sort':
                    state.showSort = !state.showSort
                    break
            }
        }
        const onSelect = action => {
            console.log(action)
        }

        const longppress = e => {}
        const previewCardCover = () => {
            showImagePreview({
                images: [state.cardDetail.coverUrl],
                startPosition: 0,
                closeable: true
            })
        }
        const toUserHome = () => {
            localStorage.setItem('userCode', state.albumDetail.userHomeId)
            router.push('/userHome')
            // window.open(`https://test.moyuxy.com/my/my_utime/res/order/index.html?userId=${state.albumDetail.userHomeId}#/homePage`)
            // window.open(`http://192.168.1.73:5173?userId=${albumStore.userHomeId}#/homePage`)
        }

        const getAlbumAttr = async () => {
            // 获取相册属性
            try {
                const {
                    userHome: {openPhotoHome, openUserHome}
                } = await useAlbumAttr({albumId, attrType: 'USER_HOME'})
                console.log('1092 ===>', openPhotoHome, openUserHome)
                albumStore.openPhotoHome = openPhotoHome
                albumStore.openUserHome = openUserHome
            } catch (error) {
                console.log('1207 ===>', error)
            }
        }
        const toMyKids = () => {
            let kidResult = localStorage.getItem('kidResult')
            if (kidResult) {
                let {photoId, similarity} = JSON.parse(kidResult)
                router.push({path: 'shareKids', query: {id: photoId, similarity}})
            }
        }
        const buyPhoto = data => {
            state.buyToast = true
            state.buyPhotoInfo = data
        }
        const agreen = type => {
            if (type == 'cancel') {
                router.replace({name: 'dissolveAlbum', state: {text: '当前暂无权限查看该相册!'}})
            } else {
                state.agreenToast = false
            }
        }
        // 批量下载
        const batchDownloadToast = () => {
            if (!state.isWechatPlatform) {
                state.modalName = 'openWechat'
                return;
            }
            if (state.tabList[state.currentTabIndex].id == 'hot') {
                onChangeTab(0)
            }
            closeChose()
            state.multipleChoseModal = true
            state.choseType = 'DOWNLOAD'
        }
        // 确定下载弹出小程序码
        const downloadMini = () => {
            if (state.chosePhotoCount == 0) {
                showNotify({type: 'warning', message: '请至少选择一张照片~'})
                return
            }
            if (state.chosePhotoCount > 1000) {
                showNotify({type: 'warning', message: '一次最多下载1000张'})
                return
            }
            const downloadList = JSON.parse(JSON.stringify(checkedList.value))
            let params = {
                albumId: state.albumDetail.id,
                photoIdList: downloadList.map(i => i.photoId),
                allLabel: state.labelList.length > 0 ? (albumStore.labelId == 0 ? true : false) : false,
                watermark: albumStore.showWatermark
            }
            downloadMiniCode(params).then(res => {
                state.qrCode = res?.qrCode
                showBatchPhoto()
            })
        }
        const handleGetInteract = () => {
            // 获取互动设置
            useAlbumAttr({albumId, attrType: 'INTERACTIVE'})
                .then(res => {
                    // console.log('res===>',res)
                    const {repeatLike,vote} = res.attrInteractive
                    state.repeatLike = repeatLike
                    state.vote = vote
                    albumStore.vote = vote
                    // console.log('albumStore.vote:', albumStore.vote)
                    if (vote) {
                        // 开启了投票
                        handleGetVoteSet()
                    }
                })
                .catch(e => {
                    console.log('获取互动设置失败：', e)
                })
        }
        const handleGetPublishPhotoNum = () => {
            // 获取发布照片数量
            if (albumId) {     
                useGetAlbumList({
                    albumId,
                    page: 0,
                    pageSize: albumStore.pageSize,
                    sortType: albumStore.sortType,
                    photoStatus: 'PUBLISHED',
                    openId: albumStore.openId
                }).then(res => {
                    // console.log('获取发布照片数量：', res)
                    if (res) {
                        state.lastUpdatePhotoCount = res?.displayCount || 0
                    }
                })
            }
        }
        const handleStartNumTimer = () => {
            // 打开照片数量检测定时器
            state.updatePhotoListTimer = setInterval(() => {
                if (!state.updatePhotoListFlag) {
                    handleGetNowAlbumNum()
                }
            }, 1000 * 10)
        }
        const handleCloseNumTimer = () => {
            // 关闭照片数量检测定时器
            clearInterval(state.updatePhotoListTimer)
            state.updatePhotoListTimer = null
        }
        const handleGetNowAlbumNum = () => {
            // 获取当前相册照片数量
            getNowAlbumNum({albumId}).then(res => {
                // state.albumDetail.photoCount = res.photoCount
                // console.log('当前相册照片数量：', res)
                if (res) {
                    const displayCount = res?.displayCount || 0
                    if (displayCount !== state.lastUpdatePhotoCount) {
                        state.updatePhotoListFlag = true
                        handleCloseNumTimer()
                        state.lastUpdatePhotoCount = displayCount
                    }
                }
            })
        }
        const handleUpdatePhotoList = () => {
            // 更新照片列表
            window.scrollTo({top: 0})
            state.multipleChoseModal = false
            // state.labelClickCount++
            // albumStore.labelId = id
            state.loadMore = true
            state.pages = 0
            photoList.value = []
            state.lightboxRefresh = true
            // console.log('635 ==>',checkedList.value)
            checkedList.value = []
            state.chosePhotoCount = 0
            // getWatermarkParams(id)
            getNextPagePhoto()
            state.updatePhotoListFlag = false
            handleStartNumTimer()
        }
        const hideModal = () => {
            state.modalName = ''
        }
        const handleGetVoteSet = () => {
            // 获取投票设置
            useAlbumAttr({ albumId, attrType: 'INTERACTIVE_VOTE' }).then(res => {
                // console.log('获取投票设置成功:',res)
                const {endTime,startTime,voteResult} = res.attrInteractiveVoteVo
                albumStore.voteStartTime = startTime
                albumStore.voteEndTime = endTime
                albumStore.voteResult = voteResult

                if (voteResult) {
                    // 开启了投票结果
                    state.tabList.push({id: 'vote', title: '排行榜'})
                }
            }).catch(err => {
                console.log('获取投票设置失败：', err)
            })
        }

        const searchFileName = () => {
            router.push('/fileNameSearch')
        }

        const ForceRoute = () => {
            // 强制跳转
            // console.log('强制路由：', state.albumDetail)
            if (state.albumDetail.forceMode === 'FACE') {
                router.push({ path: '/searchFace', query: { type: 'findPerson' } })
            } else if (state.albumDetail.forceMode === 'NUMBER') {
                router.push({ path: '/numberIdentify' })
            } else if (state.albumDetail.forceMode === 'FILE_NAME') {
                router.push('/fileNameSearch')
            }
        } 
    
        return {
            ...toRefs(state),
            photoList,
            onChangeAddress,
            onChangeTab,
            onChangeLabel,
            onchangeDisplayType,
            onChangeSortType,
            clickPerson,
            albumStore,
            close,
            tabsRef,
            join,
            showScreen,
            closeModal,
            config,
            showPluzzeToast,
            chosepuzzleMode,
            closeChose,
            choseItem,
            confirmPluzze,
            findface,
            scrollToTop,
            sharePhoto,
            chosePoster,
            onCardDetail,
            previewCardPhoto,
            toCardUrl,
            computedResources,
            isshowPopover,
            onSelect,
            longppress,
            RNPostData,
            previewCardCover,
            toUserHome,
            toMyKids,
            formatNumber,
            startBuyPhoto,
            confirmBuy,
            buyPhoto,
            swiperNextPage,
            refreshPhotoList,
            agreen,
            handleNumberIdentify,
            batchDownloadToast,
            downloadMini,
            showBatchPhoto,
            handleUpdatePhotoList,
            hideModal,
            searchFileName,
            ForceRoute
        }
    }
})
</script>

<style scoped lang="less">
.wrapper {
    height: 100vh;
    overflow: hidden;
    position: relative;
}

.content {
    position: absolute;
}

.album {
    width: 100%;
    max-width: 750px;
    display: flex;
    flex-direction: column;
}

.header {
    width: 100%;
    overflow: hidden;
}

.cardContainer {
    margin-top: 7px;
    padding: 19px;
}

.goTopButton {
    z-index: 998;
    position: fixed;
    // top: 100px;
    left: 0px;
    padding: 4px 8px 4px 4px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    line-height: 20px;
    font-size: 14px;
}

.albumPhoto {
    width: 100%;
    height: 100%;
    margin-top: 7px;
    // padding-right: 6px;
    // padding-top: 15px;
    // padding-left: 6px;
    box-sizing: border-box;
    // padding: 12px 15px 0 15px;
    // padding: 0 15px;
}

.photo {
    width: 100%;
    margin-top: 5px;
}

.normalTab {
    font-size: 15px;
    color: #c8c8c8;
    /* width: 33%; */
    display: flex;
    flex-direction: column;
    align-items: center;
}

.showAllAddress {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.packUpAddress {
    display: inline-block;
}

.activeTab {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    color: #ffffff;
}

.tabs {
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: space-between;
    padding: 0 15px;
}

.tabsTop {
    width: 100%;
    position: fixed;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    padding: 10px;
    max-width: 750px;
    z-index: 9;
}

.modalContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3vh 2vw 0 2vw;
}

.title {
    font-size: 20px;
    color: #fff;
    margin: 2vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.itemSort {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
}

.itemSort img {
    width: 5vh;
    object-fit: cover;
    /*height: 10vh;*/
    margin-bottom: 5px;
}

.imgWrapper {
    width: 32%;
    margin-right: 1%;
}

.personItem {
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    position: relative;
    margin-bottom: 8px;
}

.personItem img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: absolute;
    object-fit: cover;
}

::-webkit-scrollbar {
    display: none;
}

.mask {
    width: 100%;
    max-width: 750px;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0);
}

.mainloading {
    width: 100%;
    height: 100vh;
    z-index: 9999999;
    background: #fff;
    position: fixed;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.puzzleContainer {
    display: flex;
    flex-direction: column;
    // padding-top: 26px;
    padding: 16px 24px 24px 24px;
}

.puzzleBox {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: 16px;
}

.suspension {
    max-width: 732px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 113px;
    position: fixed;
    z-index: 999;
    left: 50%;
    transform: translate(-50%);
    bottom: 0;
}

.puzzle {
    width: 63px;
    height: 63px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    color: #fff;
    align-items: center;
    justify-content: center;
}

.multipleChoseModal {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
}
.multipleContainer {
    width: 100%;
    padding: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 14px 15px;
}

.confirmBtn {
    min-width: 123px;
    height: 32px;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 20px;
}

.multipleCardBox {
    display: flex;
    align-items: center;
    width: 100%;
    overflow-x: scroll;
}

.multipleCardCover {
    width: 90px;
    height: 68px;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 4px;
    object-fit: cover;
}

.cardDesc {
    width: 70%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    margin-top: 5px;
}

.cover {
    width: 64px;
    height: 64px;
    border-radius: 64px;
}

.cardPhotoCantainer {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
}

.cardPhoto {
    width: 30%;
    height: 30%;
    border-radius: 8px;
    margin-right: 12px;
}

.descText {
    width: 100%;
    font-weight: 500;
    margin-top: 8px;
    text-indent: 2rem;
}

.cardCell {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 11px;
    width: 90px;
}

.urlDataCell {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px 0;
}

.urlDetail {
    padding: 0 10px;
    height: 20px;
    line-height: 20px;
    margin-right: 10px;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.multipleTitle {
    text-align: center;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.footer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.urlData {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.cardtips {
    position: absolute;
    bottom: -30%;
    left: 50%;
    transform: translate(-50%);
    width: 246px;
    height: 36px;
    border: 1px solid #fff;
    color: #fff;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 36px;
}

.appointment-avatar {
    width: 40px;
    height: 40px;
    border-radius: 40px;
    object-fit: cover;
}

.btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.agreenModal {
    width: 90%;
    background: #fff;
    border-radius: 12px;
    position: absolute;
    left: 5%;
    top: 50%;
    transform: translate(0, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    .agreen-title {
        color: #000;
        font-size: 18px;
    }
    .agreen-btn {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        .agreen-cancel {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 40%;
            height: 40px;
            border-radius: 40px;
            background: #f6f6f6;
        }
        .agreen-confirm {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 40%;
            height: 40px;
            border-radius: 40px;
            background: #0396fe;
            color: #fff;
        }
    }
}
.video {
    height: auto;
    width: 100%;
    background: #333333;
}

.video::-webkit-media-controls-enclosure {
    transform: translateY(2px);
}
.discountTip {
    width: 100%;
    background: #fff4d9;
    font-size: 14px;
    color: #ff782d;
    padding: 5px 15px;
}
.updateTip {
    position: fixed;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(61, 174, 104, 0.80);
    z-index: 100;
    padding: 6px 12px;
    border-radius: 16px;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
}
.confirmBtn {
    width: 100%;
    height: 48px;
    border-radius: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
}
.pre-line-text {
    white-space: pre-line;
}
.cancelBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
    height:100%
}
</style>
